import React from 'react';
import FlexParent from 'modules/emergencies/components/ui/layout/FlexParent';
import LogReasonsContainer from 'modules/emergencies/components/ui/containers/logReasonsContainer';
import BulletPoint from 'modules/emergencies/components/ui/layout/BulletPoint';
import LOG_VERBS from './logConstants';
import t from 'modules/emergencies/components/modals/TicketUpdateTranslations';
import moment from 'moment';
import styled from 'styled-components';

const StyledLink = styled.a`
  margin-left: 20px;
`;

//components

const shouldDisplayKey = (key) => {
  return typeof key !== 'undefined' && key !== null && key.trim() !== '';
};

const getReadableEta = (eta) => {
  const date = moment(eta).format('dddd DD MMM YYYY');
  const hour = moment(eta).format('HH:mm');
  const isToday = date === moment().format('dddd DD MMM YYYY');
  const renderedDate = isToday ? `Today ${hour}` : `${date} ${hour}`;
  return renderedDate;
};

const LogItemTicketUpdateBody = ({ log }) => {
  const { update_data: updateData } = log.action_object?.data || {};
  const updateFiles = log.action_object?.data?.files || [];
  const files =
    updateFiles.map((file) => ({
      url: file.file_url,
      name: file.file_name,
    })) || [];
  return (
    <LogReasonsContainer>
      {log.verb === LOG_VERBS.DELIVERED && (
        <>
          <FlexParent>
            <BulletPoint />
            <b>{t.city}</b> : {updateData.dropoff_city}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.country}</b> : {updateData.dropoff_country}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.etaSection}</b> : {getReadableEta(updateData.eta)}
          </FlexParent>
          {shouldDisplayKey(updateData.additional_information) && (
            <FlexParent>
              <BulletPoint />
              <b>{t.detailsSection}</b> : {updateData.additional_information}
            </FlexParent>
          )}
          {files.length > 0 && (
            <FlexParent>
              <BulletPoint />
              <b>Attached imagenes:</b>
            </FlexParent>
          )}
          {files.length > 0 &&
            files.map((file) => (
              <FlexParent key={file.url}>
                <StyledLink target={'_blank'} href={file.url} rel="noreferrer">
                  {file.name}
                </StyledLink>
              </FlexParent>
            ))}
        </>
      )}
      {log.verb === LOG_VERBS.ON_THE_WAY && (
        <>
          <FlexParent>
            <BulletPoint />
            <b>{t.city}</b> : {updateData.dropoff_city}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.country}</b> : {updateData.dropoff_country}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.etaSection}</b> : {getReadableEta(updateData.eta)}
          </FlexParent>
          {shouldDisplayKey(updateData.additional_information) && (
            <FlexParent>
              <BulletPoint />
              <b>{t.detailsSection}</b> : {updateData.additional_information}
            </FlexParent>
          )}
          {files.length > 0 && (
            <FlexParent>
              <BulletPoint />
              <b>Attached imagenes:</b>
            </FlexParent>
          )}
          {files.length > 0 &&
            files.map((file) => (
              <FlexParent key={file.url}>
                <StyledLink target={'_blank'} href={file.url} rel="noreferrer">
                  {file.name}
                </StyledLink>
              </FlexParent>
            ))}
        </>
      )}
      {log.verb === LOG_VERBS.DELAYED && (
        <>
          <FlexParent>
            <BulletPoint />
            <b>{t.incidentSection}</b> : {updateData.additional_information}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>
              {t.pickupSection} {t.city}
            </b>{' '}
            : {updateData.pickup_city}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>
              {t.pickupSection} {t.country}
            </b>{' '}
            : {updateData.pickup_country}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>
              {t.dropoffSection} {t.city}
            </b>{' '}
            : {updateData.dropoff_city}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>
              {t.dropoffSection} {t.country}
            </b>{' '}
            : {updateData.dropoff_country}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.etaSection}</b> : {getReadableEta(updateData.eta)}
          </FlexParent>
          {files.length > 0 && (
            <FlexParent>
              <BulletPoint />
              <b>Attached imagenes:</b>
            </FlexParent>
          )}
          {files.length > 0 &&
            files.map((file) => (
              <FlexParent key={file.url}>
                <StyledLink target={'_blank'} href={file.url} rel="noreferrer">
                  {file.name}
                </StyledLink>
              </FlexParent>
            ))}
        </>
      )}
      {log.verb === LOG_VERBS.PICKUP && (
        <>
          <FlexParent>
            <BulletPoint />
            <b>{t.city}</b> : {updateData.pickup_city}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.country}</b> : {updateData.pickup_country}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.load}</b> : {updateData.load_detail}
          </FlexParent>
          <FlexParent>
            <BulletPoint />
            <b>{t.plate}</b> : {updateData.plate_number}
          </FlexParent>
          {files.length > 0 && (
            <FlexParent>
              <BulletPoint />
              <b>Attached imagenes:</b>
            </FlexParent>
          )}
          {files.length > 0 &&
            files.map((file) => (
              <FlexParent key={file.url}>
                <StyledLink target={'_blank'} href={file.url} rel="noreferrer">
                  {file.name}
                </StyledLink>
              </FlexParent>
            ))}
        </>
      )}
    </LogReasonsContainer>
  );
};

export default LogItemTicketUpdateBody;
